import { render, staticRenderFns } from "./MemberManagementConfig.vue?vue&type=template&id=11275984"
import script from "./MemberManagementConfig.vue?vue&type=script&lang=js"
export * from "./MemberManagementConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports